<script setup lang="ts"></script>

<template>
  <icon name="lucide:notebook-text" />
</template>

<style scoped></style>
